// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { downloadData as downloadDataInternal } from './internal/downloadData';
export function downloadData(input) {
    return downloadDataInternal(input);
}
